export enum ESiteConstraint {
  HAS_DEFINITIVE_DEACTIVATION = "HAS_DEFINITIVE_DEACTIVATION",
  HAS_TEMPORARY_DEACTIVATION = "HAS_TEMPORARY_DEACTIVATION",
  HAS_LINK_DEACTIVATION = "HAS_LINK_DEACTIVATION",
  HAS_PLANNING = "HAS_PLANNING",
  HAS_MODULATION_LIMITATION = "HAS_MODULATION_LIMITATION",
}
